import { format } from 'date-fns'

import { determineValueChange } from 'app/common/presentation'
import { formatCurrency, formatDate } from 'app/common/presentation/format'
import { AudiencesDayRevenue } from 'app/dashbaord/types'

import { Chart, PercentageIndicator } from 'components'

import { tooltipDateFormat } from '../Dashboard'
import Tile, { TileContentProps } from './Tile'
import styles from './Tile.module.scss'

interface RevenueProps extends TileContentProps {
  revenues: AudiencesDayRevenue[]
}

const Revenue = ({ days, revenues, translate }: RevenueProps) => {
  const totalRevenues = revenues.reduce((acc, revenue) => acc + revenue.total, 0)
  const totalRevenues30DaysBefore = revenues.reduce(
    (acc, session) => acc + (session.total30DaysBefore ?? 0),
    0,
  )
  const change = determineValueChange([totalRevenues, totalRevenues30DaysBefore])

  return (
    <Tile className={styles.revenue} days={days} tileKey="revenue" translate={translate}>
      <div className={styles.revenues}>
        <Chart.AreaChart
          data={revenues.map((entry) => ({ key: entry.date, value: entry.total }))}
          formatTooltipLabel={(date) => format(date, tooltipDateFormat)}
          formatXTick={formatDate}
          formatYTick={(value) => formatCurrency(value, { fractionDigits: 0 })}
          reversed
          yScaleFactor={1.5}
        />
        <div className={styles.chartInfo}>
          <div className={styles.total}>{formatCurrency(totalRevenues, { fractionDigits: 0 })}</div>
          <PercentageIndicator percentage={change} />
        </div>
      </div>
    </Tile>
  )
}

export default Revenue
